// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Field from "../layout-and-structure/Field.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Inline from "../layout-and-structure/Inline.res.js";
import * as Checkbox from "./Checkbox.res.js";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
function InputCheckboxField(props) {
  let onChange = props.onChange;
  let __disabled = props.disabled;
  let value = props.value;
  let disabled = __disabled !== undefined ? __disabled : false;
  let match = Hover.use(undefined, undefined, undefined);
  let hovered = match[1];
  let labelVariation = (value || hovered) && !disabled ? "neutral" : "normal";
  let labelWeight = value && !disabled ? "medium" : "regular";
  let newrecord = {
    ...{
      className: "display-x78zum5 marginTop-xau4c6c",
      "data-style-src": "wino-gc:src/resources/selection-and-input/InputCheckboxField.res.js:14"
    }
  };
  return JsxRuntime.jsx(Field.make, {
    children: JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(Checkbox.make, {
        disabled: disabled,
        hovered: hovered,
        value: value ? "Checked" : "Unchecked",
        onChange: onChange
      }), newrecord)), JsxRuntime.jsx(Touchable.make, {
        children: JsxRuntime.jsx(TextStyle.make, {
          children: props.text,
          variation: labelVariation,
          weight: labelWeight,
          size: "small",
          lineHeight: "medium"
        }),
        disabled: disabled,
        onPress: param => onChange(!value),
        ref: match[0]
      })],
      space: "small"
    }),
    label: props.label,
    tooltip: props.tooltip,
    errorMessage: props.errorMessage,
    required: props.required
  });
}
let make = React.memo(InputCheckboxField);
export { make };
/* styles Not a pure module */